/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateLocationCodeCommand } from '../model';
// @ts-ignore
import type { LocationCodeDto } from '../model';
// @ts-ignore
import type { UpdateGlobalLocationCodesCommand } from '../model';
// @ts-ignore
import type { UpdateLocationCodeCommand } from '../model';
/**
 * LocationCodesApi - axios parameter creator
 */
export const LocationCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateLocationCodeCommand} [createLocationCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createLocationCodeCommand?: CreateLocationCodeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/LocationCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationCodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/LocationCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [codes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCodeNames: async (codes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/LocationCodes/GetLocationCodeNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (codes) {
                localVarQueryParameter['Codes'] = codes;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {boolean} [isFilterByCode] 
         * @param {boolean} [onlyShowActive] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchedLocationCodes: async (filter?: string, isFilterByCode?: boolean, onlyShowActive?: boolean, take?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/LocationCodes/GetMatchedLocationCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (isFilterByCode !== undefined) {
                localVarQueryParameter['IsFilterByCode'] = isFilterByCode;
            }

            if (onlyShowActive !== undefined) {
                localVarQueryParameter['OnlyShowActive'] = onlyShowActive;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGlobalLocationCodesCommand} [updateGlobalLocationCodesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshGlobal: async (updateGlobalLocationCodesCommand?: UpdateGlobalLocationCodesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/LocationCodes/UpdateGlobal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGlobalLocationCodesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateLocationCodeCommand} [updateLocationCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateLocationCodeCommand?: UpdateLocationCodeCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/LocationCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationCodeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationCodesApi - functional programming interface
 */
export const LocationCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateLocationCodeCommand} [createLocationCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createLocationCodeCommand?: CreateLocationCodeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createLocationCodeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationCodesApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationCodesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [codes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationCodeNames(codes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationCodeNames(codes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationCodesApi.getLocationCodeNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {boolean} [isFilterByCode] 
         * @param {boolean} [onlyShowActive] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchedLocationCodes(filter?: string, isFilterByCode?: boolean, onlyShowActive?: boolean, take?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchedLocationCodes(filter, isFilterByCode, onlyShowActive, take, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationCodesApi.getMatchedLocationCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateGlobalLocationCodesCommand} [updateGlobalLocationCodesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshGlobal(updateGlobalLocationCodesCommand?: UpdateGlobalLocationCodesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshGlobal(updateGlobalLocationCodesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationCodesApi.refreshGlobal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateLocationCodeCommand} [updateLocationCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateLocationCodeCommand?: UpdateLocationCodeCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateLocationCodeCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationCodesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationCodesApi - factory interface
 */
export const LocationCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationCodesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateLocationCodeCommand} [createLocationCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createLocationCodeCommand?: CreateLocationCodeCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.create(createLocationCodeCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationCodeDto>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [codes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationCodeNames(codes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getLocationCodeNames(codes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {boolean} [isFilterByCode] 
         * @param {boolean} [onlyShowActive] 
         * @param {number} [take] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchedLocationCodes(filter?: string, isFilterByCode?: boolean, onlyShowActive?: boolean, take?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationCodeDto>> {
            return localVarFp.getMatchedLocationCodes(filter, isFilterByCode, onlyShowActive, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateGlobalLocationCodesCommand} [updateGlobalLocationCodesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshGlobal(updateGlobalLocationCodesCommand?: UpdateGlobalLocationCodesCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.refreshGlobal(updateGlobalLocationCodesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateLocationCodeCommand} [updateLocationCodeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateLocationCodeCommand?: UpdateLocationCodeCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(updateLocationCodeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationCodesApi - object-oriented interface
 */
export class LocationCodesApi extends BaseAPI {
    /**
     * 
     * @param {CreateLocationCodeCommand} [createLocationCodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(createLocationCodeCommand?: CreateLocationCodeCommand, options?: RawAxiosRequestConfig) {
        return LocationCodesApiFp(this.configuration).create(createLocationCodeCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAll(options?: RawAxiosRequestConfig) {
        return LocationCodesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [codes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLocationCodeNames(codes?: Array<string>, options?: RawAxiosRequestConfig) {
        return LocationCodesApiFp(this.configuration).getLocationCodeNames(codes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {boolean} [isFilterByCode] 
     * @param {boolean} [onlyShowActive] 
     * @param {number} [take] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMatchedLocationCodes(filter?: string, isFilterByCode?: boolean, onlyShowActive?: boolean, take?: number, options?: RawAxiosRequestConfig) {
        return LocationCodesApiFp(this.configuration).getMatchedLocationCodes(filter, isFilterByCode, onlyShowActive, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateGlobalLocationCodesCommand} [updateGlobalLocationCodesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshGlobal(updateGlobalLocationCodesCommand?: UpdateGlobalLocationCodesCommand, options?: RawAxiosRequestConfig) {
        return LocationCodesApiFp(this.configuration).refreshGlobal(updateGlobalLocationCodesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateLocationCodeCommand} [updateLocationCodeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update(updateLocationCodeCommand?: UpdateLocationCodeCommand, options?: RawAxiosRequestConfig) {
        return LocationCodesApiFp(this.configuration).update(updateLocationCodeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

